import React from 'react';
import Popout from './popout';
import ClickOutside from './click-outside';
import * as styles from './anchored-popout.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AnchoredPopout = _ref => {
  var className = _ref.className,
    Anchor = _ref.anchor,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    align = _ref.align,
    children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$onClickOutside = _ref.onClickOutside,
    onClickOutside = _ref$onClickOutside === void 0 ? () => {} : _ref$onClickOutside;
  return ___EmotionJSX("div", {
    css: styles.anchor,
    className: className
  }, ___EmotionJSX(ClickOutside, {
    onClickOutside: onClickOutside
  }, ___EmotionJSX(Anchor, {
    onClick: onClick
  }), isOpen && ___EmotionJSX("div", {
    css: styles.popoutWrapper({
      align
    })
  }, ___EmotionJSX(Popout, {
    align: align
  }, children))));
};
export default AnchoredPopout;